module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pp-content__page"
  }, [_c('div', {
    staticClass: "pp-tabs"
  }, [_c('ul', {
    staticClass: "pp-tabs__headers"
  }, [_c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse"
    }
  }, [_vm._v("\n                        Popular\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/albums"
    }
  }, [_vm._v("\n                        Albums\n                    ")])], 1), _vm._v(" "), (_vm.$root.view != 'mobile') ? _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/tracks"
    }
  }, [_vm._v("\n                        Tracks\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.view == 'mobile') ? _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/new"
    }
  }, [_vm._v("\n                        New\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/composers"
    }
  }, [_vm._v("\n                        Composers\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/ensembles"
    }
  }, [_vm._v("\n                        Ensembles\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/artists"
    }
  }, [_vm._v("\n                        Artists\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/exclusive"
    }
  }, [_vm._v("\n                        Exclusives\n                    ")])], 1), _vm._v(" "), (_vm.$root.view == 'mobile') ? _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/tracks"
    }
  }, [_vm._v("\n                        Tracks\n                    ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pp-welcome"
  }, [(!_vm.$root.account.id || !_vm.$root.account.plan) ? _c('div', {
    staticClass: "pp-welcome__left"
  }, [_c('div', {
    staticClass: "pp-welcome__header"
  }, [_vm._v("\n                        Get started\n                    ")]), _vm._v(" "), (!_vm.$root.account.id && !_vm.$root.account.plan) ? _c('p', {
    staticClass: "pp-welcome__paragraph"
  }, [_vm._v("\n                        If you're already a Pristine Streaming subscriber, simply click the button\n                        below to log in.\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$root.account.id && !_vm.$root.account.plan) ? _c('p', {
    staticClass: "pp-welcome__paragraph"
  }, [_vm._v("\n                        If you're not yet a Pristine Streaming subscriber, simply click the button\n                        below to subscribe.\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$root.account.id && !_vm.$root.account.plan && !_vm.$root.isIos) ? _c('p', {
    staticClass: "pp-welcome__paragraph"
  }, [_vm._v("\n                        Not subscribed yet? Subscribing only take a couple of seconds\n                        and gives you access to our entire library.\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$root.account.id && !_vm.$root.account.plan) ? _c('p', {
    staticClass: "pp-welcome__paragraph"
  }, [_vm._v("\n                        Subscribing only take a couple of seconds\n                        and gives you access to our entire library.\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$root.account.id && !_vm.$root.account.plan) ? _c('a', {
    staticClass: "pp-welcome__button",
    attrs: {
      "href": 'https://www.pristineclassical.com/pages/player-subscribe?mode=' + _vm.$root.view + '&signin_hidden=' + (_vm.$root.isIos ? 'true' : 'false')
    }
  }, [_vm._v("\n                        Login with your Pristine Classical account\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$root.isIos) ? _c('div', [(_vm.$root.account.id && !_vm.$root.account.plan) ? _c('a', {
    staticClass: "pp-welcome__button",
    attrs: {
      "href": 'https://www.pristineclassical.com/pages/player-subscribe?mode=' + _vm.$root.view
    }
  }, [_vm._v("\n                            Subscribe to Pristine Streaming\n                        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pp-welcome__button pp-welcome__button--secondary",
    attrs: {
      "to": "/browse"
    }
  }, [_vm._v("\n                        Browse and listen for free\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.account.id && _vm.$root.account.plan) ? _c('div', {
    staticClass: "pp-welcome__left"
  }, [_c('div', {
    staticClass: "pp-welcome__header"
  }, [_vm._v("\n                        Start exploring\n                    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "pp-welcome__paragraph"
  }, [_vm._v("\n                        Your subscription gives you unlimited access to our entire library.\n                        To start exploring, use the links in the sidebar.\n                    ")]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (!_vm.$root.account.id || !_vm.$root.account.plan) ? _c('div', {
    staticClass: "pp-welcome__right"
  }, [_c('div', {
    staticClass: "pp-welcome__header"
  }, [_vm._v("\n                        What's available?\n                    ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "pp-welcome__paragraph"
  }, [_vm._v("\n                        FLAC streaming available on the latest versions of Google Chrome, Mozilla Firefox or Microsoft Edge.\n                    ")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pp-welcome__row"
  }, [(!_vm.$root.account.id || !_vm.$root.account.plan) ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "pp-welcome__header"
  }, [_vm._v("\n                            Try it for free\n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "pp-welcome__paragraph"
  }, [_vm._v("\n                            To get a taste of the huge selection available, you can play up to five\n                            tracks completely free: no registration required.\n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "pp-welcome__paragraph"
  }, [_vm._v("\n                            Give it a try with one of the tracks below, or start exploring our library:\n                        ")]), _vm._v(" "), (_vm.loadingTracks) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.tracks.length > 0) ? _c('track-list', {
    attrs: {
      "items": _vm.tracks
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pp-welcome__button pp-welcome__button--secondary",
    attrs: {
      "to": "/browse"
    }
  }, [_vm._v("\n                            Start exploring\n                        ")])], 1) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-header pp-header--simple pp-header--image-generic"
  }, [_c('div', {
    staticClass: "pp-header__title"
  }, [_vm._v("\n            Pristine Streaming\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pp-header__content"
  }, [_vm._v("\n            Welcome to Pristine Streaming: the best historic recordings, streamed in pristine high resolution sound.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pp-welcome__paragraph"
  }, [_c('strong', [_vm._v("Thanks for subscribing to Pristine Streaming!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pp-welcome__paragraph"
  }, [_vm._v("\n                        If you have any questions or technical issues with the service, please contact\n                        "), _c('a', {
    attrs: {
      "href": "mailto:andrew@pristineaudio.com"
    }
  }, [_vm._v("\n                            andrew@pristineaudio.com\n                        ")]), _vm._v(" for support.\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pp-welcome__checklist"
  }, [_c('li', [_vm._v("The greatest library of historic classical music at your fingertips.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("12,000+")]), _vm._v(" unique, remastered classics.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("2,500+")]), _vm._v(" composers, ensembles, and artists.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("1,000")]), _vm._v(" exclusive Pristine Streaming tracks.")]), _vm._v(" "), _c('li', [_vm._v("Listen in either 320kbps MP3 or "), _c('strong', [_vm._v("high-quality FLAC")]), _vm._v(".")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-184483c4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/routes/Welcome.vue
// module id = 119
// module chunks = 0 1